.copy {
    cursor: pointer;
    svg:hover {
        stroke: rgba(#1B0777, 0.5);
    }
}